import { ConvertDurationInYearsFilter } from "./fourdotfive-convert-duration-in-years.filter";
import { ClientOrBuModifiedFilter } from "./fourdotfive-client-or-bu-modified.filter";
import { CompanyNameSettingFilter } from "./fourdotfive-company-name-setting.filter";
import { CompanyNameFilter } from "./fourdotfive-company-name.filter";
import { FourDotFiveDateFormat } from "./fourdotfive-date-format.filter";
import { PhoneNumberFilter } from "./fourdotfive-phone-number.filter";
import { ProfileFilter } from "./fourdotfive-profile.filter";
import { ShowBannerMessageFilter } from "./fourdotfive-show-banner-message.filter";
import { SingleDropdownSelectFilter } from "./fourdotfive-single-dropdown-select.filter";
import { SubStringFilter } from "./fourdotfive-substring.filter";
import { FourDotFiveTimeFormatFilter } from "./fourdotfive-time-format.filter";
import { FourDotFiveTimeStampFormatFilter } from "./fourdotfive-time-stamp-format.filter";
import { CompanyNameSettingsFilter } from "./fourdotfive-company-name-settings.filter";
import { DisplayOnMultiSelectFilter } from "./fourdotfive-display-on-multi-select.filter";
import { DisplayOnSmallMultiSelectFilter } from "./fourdotfive-display-on-small-multi-select.filter";
import { ContractDurationFilter } from "./contract-duration.filter";
export var FiltersModule = angular
    .module('4dot5.filtersModule', [])
    .filter(ConvertDurationInYearsFilter.name, ConvertDurationInYearsFilter.filter)
    .filter(ClientOrBuModifiedFilter.name, ClientOrBuModifiedFilter.filter)
    .filter(CompanyNameSettingFilter.name, CompanyNameSettingFilter.filter)
    .filter(CompanyNameSettingsFilter.name, CompanyNameSettingsFilter.filter)
    .filter(DisplayOnMultiSelectFilter.name, DisplayOnMultiSelectFilter.filter)
    .filter(DisplayOnSmallMultiSelectFilter.name, DisplayOnSmallMultiSelectFilter.filter)
    .filter(CompanyNameFilter.name, CompanyNameFilter.filter)
    .filter(PhoneNumberFilter.name, PhoneNumberFilter.filter)
    .filter(ProfileFilter.name, ProfileFilter.filter)
    .filter(ShowBannerMessageFilter.name, ShowBannerMessageFilter.filter)
    .filter(SingleDropdownSelectFilter.name, SingleDropdownSelectFilter.filter)
    .filter(SubStringFilter.name, SubStringFilter.filter)
    .filter(FourDotFiveDateFormat.name, FourDotFiveDateFormat.filter)
    .filter(FourDotFiveTimeFormatFilter.name, FourDotFiveTimeFormatFilter.filter)
    .filter(FourDotFiveTimeStampFormatFilter.name, FourDotFiveTimeStampFormatFilter.filter)
    .filter(ContractDurationFilter.name, ContractDurationFilter.filter)
    .name;
//# sourceMappingURL=filters.module.js.map